import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { DocumentsLibrary } from '../../Models/Domains/Documents/DocumentsLibrary';
import { IJsonDate } from '../../System/IJsonDate';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class DocumentsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyIds: Array<string>, fromDate: IJsonDate, toDate: IJsonDate, searchQuery: string, minRow: number, maxRow: number, taskRequestIds: Array<number>): Promise<DocumentsLibrary, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/Documents/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, fromDate: fromDate, toDate: toDate, searchQuery: searchQuery, minRow: minRow, maxRow: maxRow, taskRequestIds: taskRequestIds }

    return AjaxWrapper.get<DocumentsLibrary, any>(url, data);
  }
  public put(documentId: number, hierarchyId: string, status: string): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/Documents/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { documentId: documentId, hierarchyId: hierarchyId, status: status }

    return AjaxWrapper.put<Array<ServiceValidationError>, any>(url, data);
  }
}

